import { useEffect, useRef, useState } from 'react';
import QRCodeLib from 'qrcode';
import toast from 'react-hot-toast';

import styles from './QRCode.module.css';

interface QRCodeProps {
    value: string;
    size?: number;
}

export function QRCode({ value, size = 200 }: QRCodeProps) {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!canvasRef.current || !value) return;
        setError(false);
        QRCodeLib.toCanvas(canvasRef.current, value, {
            width: size,
            margin: 2,
            color: {
                dark: '#1C1917',
                light: '#FFFFFF',
            },
        }).catch(() => {
            setError(true);
            toast.error('No se pudo generar el codigo QR');
        });
    }, [value, size]);

    if (error) {
        return (
            <div className={styles.error}>
                <span>No se pudo generar el QR</span>
            </div>
        );
    }

    return (
        <div className={styles.wrapper}>
            <canvas
                ref={canvasRef}
                className={styles.canvas}
                aria-label="Codigo QR"
                role="img"
            />
        </div>
    );
}
